import type { Category } from '@wix/add-panel-common';
import { useEffect, useRef } from 'react';
import { useActionsDispatcher } from '../ActionsDispatcher';
import { findSectionInGroups } from '../utils';
import { isVerticalCategory, isVerticalInstalledCategory } from '../utils/category';

export const useDispatchCategoryOpen = (
  category: Category,
  selectedSectionSystemId: string,
  scrollBiParams: {
    category_under_scroll: boolean;
    isScrollable: boolean | null;
    window_width: number;
    window_height: number;
  },
) => {
  const { dispatchCategoryOpen } = useActionsDispatcher();

  const categoryId = category.id;
  const dispatchCategoryOpenRef = useRef<(categoryId: string) => void>(() => undefined);

  dispatchCategoryOpenRef.current = (_categoryId: string) => {
    dispatchCategoryOpen({
      categoryId: _categoryId,
      sectionName: findSectionInGroups(selectedSectionSystemId, category.groups)?.sectionName || '',
      bi: {
        is_vertical_installed: isVerticalCategory(category) ? isVerticalInstalledCategory(category) : null,
        ...scrollBiParams,
      },
    });
  };

  useEffect(() => {
    dispatchCategoryOpenRef.current(categoryId);
  }, [categoryId]);
};

export const useDispatchSectionOpen = (category: Category, selectedSectionSystemId: string) => {
  const { dispatchSectionOpen } = useActionsDispatcher();

  const categoryId = category.id;
  const dispatchSectionOpenRef = useRef<(categoryId: string, selectedSectionSystemId: string) => void>(() => undefined);

  dispatchSectionOpenRef.current = (_categoryId: string, _selectedSectionSystemId: string) => {
    dispatchSectionOpen({
      categoryId: _categoryId,
      sectionName: findSectionInGroups(_selectedSectionSystemId, category.groups)?.sectionName || '',
    });
  };

  useEffect(() => {
    dispatchSectionOpenRef.current(categoryId, selectedSectionSystemId);
  }, [categoryId, selectedSectionSystemId]);
};
